<template>
    <div class="cost-body px-3">
        <h5 class="font-weight-bold text-main-color mb-3">{{ tra.additional_costs }}</h5>
        
        <div v-if="(dataObj.course?.textbooks_fees_value || 0) != 0">
            <span class="d-block">
                <span class="font-weight-bold">{{ tra.textbook_fees }} : </span>
                <span class="text-main-color">
                    {{ dataObj.course?.textbooks_fees || 0 }}
                    <span class="small text-dark">
                        {{ (dataObj.currency?.code || 'SAR') == 'SAR' ? ' ' : (dataObj.currency?.code || 'SAR') }}
                    </span>
                </span>
            </span>
            <hr />
        </div>
        
        <div v-if="dataObj.additional_fees_data">
            <div v-for="fees in (dataObj.additional_fees_data.fees_list || [])" :key="fees.name">
                <span class="d-block">
                    <span class="font-weight-bold">{{ fees.name || '' }} : </span>
                    <span class="text-main-color">
                        {{ fees.fees || 0 }}
                        <span class="small text-dark">
                            {{ (dataObj.currency?.code || 'SAR') == 'SAR' ? ' ' : (dataObj.currency?.code || 'SAR') }}
                        </span>
                    </span>
                </span>
                <span v-if="(fees.weeks || 0) > 0" class="h6 text-main-color">
                    ({{ weeksOutput(fees.weeks) }})
                </span>
                <hr />
            </div>
        </div>
        
        <div v-if="dataObj.course?.discount_obj?.coupon_discount_amount">
            <span class="d-block">
                <span class="font-weight-bold">{{ tra.discount_coupon_value }} : </span> 
                <span class="text-danger">
                    {{ dataObj.course?.discount_obj?.coupon_discount_amount || 0 }}
                    <span class="small text-dark">
                        {{ (dataObj.currency?.code || 'SAR') == 'SAR' ? ' ' : (dataObj.currency?.code || 'SAR') }}
                    </span>
                </span>
            </span>
            <hr class="my-2">
        </div>
    </div>
</template>

<script>
export default {
    name: 'AdditionalCosts',
    props: {
        dataObj: Object,
        tra: Object,
    },
    methods: {
        weeksOutput(weeks) {
            let msg = '';
            if (weeks == 1) { 
                msg = this.tra.weeks_singular || 'اسبوع'; 
            }
            else if (weeks == 2) { 
                msg = this.tra.two_weeks_option || 'اسبوعان'; 
            }
            else if (weeks > 2 && weeks < 11) { 
                msg = weeks + ' ' + (this.tra.weeks || 'اسابيع'); 
            }
            else { 
                msg = weeks + ' ' + (this.tra.weeks_singular || 'اسبوع'); 
            }
            return msg;
        }
    }
};
</script>